import moment from "moment";

export const formatDate = (dateInSeconds: number): string => new Date(dateInSeconds * 1000).toLocaleDateString("en-US");

export const formatDateFromMillis = (dateInMilliseconds: number): string =>
  new Date(dateInMilliseconds).toLocaleDateString("en-US");

export const getParams = (start: Date, end: Date): { params: { start: string; end: string } } => {
  return {
    params: {
      start: String(moment(start).startOf("day").valueOf()),
      end: String(moment(end).endOf("day").valueOf()),
    },
  };
};
